import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  getDefaultersDataService,
  verifyDefaulterService,
} from "../../../service/defaulters.service";
import {
  getDefaultersDataFailure,
  getDefaultersDataSuccess,
  verifyDefaulterFailure,
  verifyDefaulterSuccess,
} from "./actions";

function* getDefaultersData() {
  const selectedToken = (state) => state.auth.token;

  try {
    const token = yield select(selectedToken);
    const response = yield call(getDefaultersDataService, {
      token,
    });

    if (response.status !== 200)
      throw new Error("Failed to get Defaulters Data");

    const { data } = response;

    yield put(
      getDefaultersDataSuccess({
        data: data.debtors,
      })
    );
  } catch (error) {
    yield put(getDefaultersDataFailure(error));
  }
}

function* verifyDefaulter({ payload }) {
  const selectedToken = (state) => state.auth.token;

  try {
    const token = yield select(selectedToken);
    const response = yield call(verifyDefaulterService, {
      token,
      contractNumber: payload.contractNumber,
    });

    if (response.status !== 200)
      throw new Error("Failed to verify contract as defaulter");

    const { data } = response;

    yield put(
      verifyDefaulterSuccess({
        isDefaulter: data.debtors.length > 0,
      })
    );
  } catch (error) {
    yield put(verifyDefaulterFailure(error));
  }
}

export default all([
  takeLatest("DEFAULTERS_GET_DATA", getDefaultersData),
  takeLatest("VERIFY_DEFAULTER", verifyDefaulter),
]);
